var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack225({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.85,8.28a5.44,5.44,0,0,1,.4-2.2,3.91,3.91,0,0,1,.8-1.18,3.05,3.05,0,0,1,1.11-.77A4.63,4.63,0,0,1,8,3.79a4.06,4.06,0,0,1,3,1.17,4.53,4.53,0,0,1,1.14,3.28,4.49,4.49,0,0,1-1.13,3.25,4,4,0,0,1-3,1.18A4,4,0,0,1,5,11.5,4.41,4.41,0,0,1,3.85,8.28Zm1.79-.06a3.21,3.21,0,0,0,.68,2.21A2.15,2.15,0,0,0,8,11.19a2.17,2.17,0,0,0,1.7-.75,3.31,3.31,0,0,0,.66-2.24A3.26,3.26,0,0,0,9.75,6,2.22,2.22,0,0,0,8,5.27,2.2,2.2,0,0,0,6.3,6,3.24,3.24,0,0,0,5.64,8.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack225);
export default __webpack_public_path__ + "static/media/Symbolpack_2_25.4bc5dedd783915e601cbcc9f645c2850.svg";
export { ForwardRef as ReactComponent };